import BaseModel from '../core/BaseModel'
import {constants} from "../services/constants";
import moment from "moment";
//import {constants}  from '../services/constants'
//import moment from "moment-timezone";
export default class ReportAppraisalProductModel extends BaseModel {
    constructor() {
        super({ 
                name: "report_appraisal_product",
                tableName: 'core_request_return_product'
            }, 
            {
            id: { 
                name: 'id', 
                type: "String", 
                label: 'ID',
                primaryKey: true,
                display: false,
            },
            fullname_text: {
                name: 'fullname_text',
                type: "String",
                label: 'Tên khách hàng',
                width: 13,
                sortable: false,
                computed: (data) => {
                    var records = data.request_activation;
                    var fullname_text = "";
                    if (records){
                        if (records.customer_profile != undefined && records.customer_profile != null) {
                            fullname_text = records.customer_profile.full_name;
                        }
                        if (records.customer_name != undefined && records.customer_name != null ) {
                            fullname_text = records.customer_name;
                        }
                    }
                    data.fullname_text = fullname_text;
                }
            },
            phone_text: {
                name: 'phone_text',
                type: "String",
                label: 'SĐT khách hàng',
                width: 13,
                sortable: false,
                computed: (data) => {
                    var records = data.request_activation;
                    var text_data = "";
                    if (records){
                        if (records.customer_profile != undefined && records.customer_profile != null) {
                            text_data = records.customer_profile.phone_number;
                            text_data = text_data.replace('+84', '0');
                        }
                    }
                    data.phone_text = text_data;
                }
            },
            address_text: {
                name: 'address_text',
                type: "String",
                label: 'Địa chỉ khách hàng',
                width: 13,
                sortable: false,
                computed: (data) => {
                    var text_data = "";
                    if (data.request_activation) {
                        if (data.request_activation.customer_profile){
                            text_data = constants.convertAddressCustomer(data.request_activation.customer_profile);
                        }
                    }
                    data.address_text = text_data;
                }
            },
            organization_return_text: {
                name: 'organization_return_text',
                type: "String",
                label: 'Đơn vị đổi - trả',
                width: 13,
                sortable: false,
                computed: (data) => {
                    var text_data = "";
                    if (!constants.isEmpty(data.user_created_request)) {
                        if (!constants.isEmpty(data.user_created_request.organization_account)){
                            if (!constants.isEmpty(data.user_created_request.organization_account.organization)){
                                text_data = (!constants.isEmpty(data.user_created_request.organization_account.organization.name))  ? data.user_created_request.organization_account.organization.name:'';
                            }
                        }
                    }
                    data.organization_return_text = text_data;
                }
            },
            phone_organization_return_text: {
                name: 'phone_organization_return_text',
                type: "String",
                label: 'SĐT đơn vị đổi -trả',
                width: 13,
                sortable: false,
                computed: (data) => {
                    var text_data = "";
                    if (!constants.isEmpty(data.user_created_request)) {
                        if (!constants.isEmpty(data.user_created_request.organization_account)){
                            if (!constants.isEmpty(data.user_created_request.organization_account.organization)){
                                var phone_number = (!constants.isEmpty(data.user_created_request.organization_account.organization.phone_number))  ? data.user_created_request.organization_account.organization.phone_number:'';
                                text_data = phone_number.replace('+84', '0');
                            }
                        }
                    }
                    data.phone_organization_return_text = text_data;
                }
            },
            province_organization_return_text: {
                name: 'province_organization_return_text',
                type: "String",
                label: 'Tỉnh/TP của ĐV đổi - trả',
                width: 13,
                sortable: false,
                computed: (data) => {
                    var text_data = "";
                    if (!constants.isEmpty(data.user_created_request)) {
                        if (!constants.isEmpty(data.user_created_request.organization_account)){
                            if (!constants.isEmpty(data.user_created_request.organization_account.organization)){
                                var provinces = (!constants.isEmpty(data.user_created_request.organization_account.organization.provinces))  ? data.user_created_request.organization_account.organization.provinces:null;
                                if (!constants.isEmpty(provinces)){
                                    text_data = (!constants.isEmpty(provinces.name)) ? provinces.name:'';
                                }
                            }
                        }
                    }
                    data.province_organization_return_text = text_data;
                }
            },
            fullname_return_text: {
                name: 'fullname_return_text',
                type: "String",
                label: 'Nhân viên đổi - trả',
                width: 13,
                sortable: false,
                computed: (data) => {
                    var text_data = "";
                    if (!constants.isEmpty(data.user_created_request)) {
                        text_data = (!constants.isEmpty(data.user_created_request.full_name))  ? data.user_created_request.full_name:'';
                    }
                    data.fullname_return_text = text_data;
                }
            },
            model_return_text: {
                name: 'model_return_text',
                type: "String",
                label: 'Model đổi - trả',
                width: 13,
                sortable: false,
                computed: (data) => {
                    var text_data = "";
                    if (!constants.isEmpty(data.serial_number)) {
                        if (!constants.isEmpty(data.serial_number.product)){
                            text_data = (!constants.isEmpty(data.serial_number.product.model_code))  ? data.serial_number.product.model_code:'';
                        }
                    }
                    data.model_return_text = text_data;
                }
            },
            name_product_return_text: {
                name: 'name_product_return_text',
                type: "String",
                label: 'Tên sản phẩm đổi - trả',
                width: 13,
                sortable: false,
                computed: (data) => {
                    var text_data = "";
                    if (!constants.isEmpty(data.serial_number)) {
                        if (!constants.isEmpty(data.serial_number.product)){
                            text_data = (!constants.isEmpty(data.serial_number.product.name))  ? data.serial_number.product.name:'';
                        }
                    }
                    data.name_product_return_text = text_data;
                }
            },
            category_return_text: {
                name: 'category_return_text',
                type: "String",
                label: 'Loại sản phẩm đổi - trả',
                width: 13,
                sortable: false,
                computed: (data) => {
                    var text_data = "";
                    if (!constants.isEmpty(data.serial_number)) {
                        if (!constants.isEmpty(data.serial_number.product)){
                        if (!constants.isEmpty(data.serial_number.product.categories)){
                            text_data = (!constants.isEmpty(data.serial_number.product.categories.name))  ? data.serial_number.product.categories.name:'';
                        }
                        }
                    }
                    data.category_return_text = text_data;
                }
            },
            serial_number_return_text: {
                name: 'serial_number_return_text',
                type: "String",
                label: 'Serial number SP đổi - trả',
                width: 13,
                sortable: false,
                computed: (data) => {
                    var text_data = "";
                    if (!constants.isEmpty(data.serial_number)) {
                        text_data = (!constants.isEmpty(data.serial_number.serial_number))  ? data.serial_number.serial_number:'';
                    }
                    data.serial_number_return_text = text_data;
                }
            },
            production_order_code_return_text: {
                name: 'production_order_code_return_text',
                type: "String",
                label: 'LSX SP đổi - trả',
                width: 13,
                sortable: false,
                computed: (data) => {
                    var text_data = "";
                    if (!constants.isEmpty(data.serial_number)) {

                        text_data = (!constants.isEmpty(data.serial_number.production_order_code))  ? data.serial_number.production_order_code:'';
                    }
                    data.production_order_code_return_text = text_data;
                }
            },
            activation_date_return_text: {
                    name: 'activation_date_return_text',
                    type: "Date",
                    label: 'Ngày kích hoạt SP đổi - trả',
                    width: 13,
                    sortable: false,
                    computed: (data) => {
                        var date_data = null;
                        if (!constants.isEmpty(data.serial_number)){
                            if (!constants.isEmpty(data.serial_number.product_serial_number_info)) {
                                if (!constants.isEmpty(data.serial_number.product_serial_number_info.activation_date)) {
                                    date_data = data.serial_number.product_serial_number_info.activation_date;
                                }
                            }
                        }
                        data.activation_date_return_text = date_data;
                    }
                },
                model_code_new_text: {
                    name: 'model_code_new_text',
                    type: "String",
                    label: 'Model SP mới',
                    width: 13,
                    sortable: false,
                    computed: (data) => {
                        var text_data = "";
                        if (!constants.isEmpty(data.change_serial_number)) {
                            if (!constants.isEmpty(data.change_serial_number.product)) {
                                text_data = (!constants.isEmpty(data.change_serial_number.product.model_code)) ? data.change_serial_number.product.model_code : '';
                            }
                        }
                        data.model_code_new_text = text_data;
                    }
                },
                name_product_new_text: {
                    name: 'name_product_new_text',
                    type: "String",
                    label: 'Tên sản phẩm SP mới',
                    width: 13,
                    sortable: false,
                    computed: (data) => {
                        var text_data = "";
                        if (!constants.isEmpty(data.change_serial_number)) {
                            if (!constants.isEmpty(data.change_serial_number.product)) {
                                text_data = (!constants.isEmpty(data.change_serial_number.product.name)) ? data.change_serial_number.product.name : '';
                            }
                        }
                        data.name_product_new_text = text_data;
                    }
                },
                category_new_text: {
                    name: 'category_new_text',
                    type: "String",
                    label: 'Loại sản phẩm mới',
                    width: 13,
                    sortable: false,
                    computed: (data) => {
                        var text_data = "";
                        if (!constants.isEmpty(data.change_serial_number)) {
                            if (!constants.isEmpty(data.change_serial_number.product)) {
                            if (!constants.isEmpty(data.change_serial_number.product.categories)) {
                                text_data = (!constants.isEmpty(data.change_serial_number.product.categories.name)) ? data.change_serial_number.product.categories.name : '';
                            }
                        }
                        }
                        data.category_new_text = text_data;
                    }
                },
                serial_number_new_text: {
                    name: 'serial_number_new_text',
                    type: "String",
                    label: 'Serial number SP mới',
                    width: 13,
                    sortable: false,
                    computed: (data) => {
                        var text_data = "";
                        if (!constants.isEmpty(data.change_serial_number)) {
                            text_data = (!constants.isEmpty(data.change_serial_number.serial_number)) ? data.change_serial_number.serial_number : '';
                        }
                        data.serial_number_new_text = text_data;
                    }
                },
                activation_date_new_text: {
                    name: 'activation_date_new_text',
                    type: "Date",
                    label: 'Ngày kích hoạt SP mới',
                    width: 13,
                    sortable: false,
                    computed: (data) => {
                        var date_data = null;
                        if (!constants.isEmpty(data.change_serial_number)){
                            if (!constants.isEmpty(data.change_serial_number.product_serial_number_info)) {
                                if (!constants.isEmpty(data.change_serial_number.product_serial_number_info.activation_date)) {
                                    date_data = data.change_serial_number.product_serial_number_info.activation_date;
                                }
                            }
                        }
                        data.activation_date_new_text = date_data;
                    }
                },
                return_type_text: {
                    name: 'return_type_text',
                    type: "String",
                    label: 'Loại dịch vụ',
                    width: 13,
                    sortable: false,
                    computed: (data) => {
                        var text_data = "";
                        if (!constants.isEmpty(data.return_type)) {
                            if (data.return_type == 1){
                                text_data = "Trả sản phẩm";
                            }else if (data.return_type == 0){
                                text_data = "Đổi sản phẩm";
                            }
                        }
                        data.return_type_text = text_data;
                    }
                },
                create_date_return_text: {
                    name: 'create_date_return_text',
                    type: "Date",
                    label: 'Ngày đổi - trả',
                    width: 13,
                    sortable: false,
                    computed: (data) => {
                        var date_data = null;
                        if (!constants.isEmpty(data.created_date)){
                            date_data = data.created_date;
                        }
                        data.create_date_return_text = date_data;
                    }
                },
                time_exchange_return_text: {
                    name: 'time_exchange_return_text',
                    type: "String",
                    label: 'Thời hạn đổi - trả',
                    width: 13,
                    sortable: false,
                    computed: (data) => {
                        var text_data = "";
                        if (!constants.isEmpty(data.serial_number)) {
                            if (!constants.isEmpty(data.serial_number.product_serial_number_info)){
                                var record_data = data.serial_number.product_serial_number_info;
                                //var warranty_time = record_data.warranty_time;
                                var returnable_time = record_data.returnable_time;
                                var change_time = record_data.change_time;
                                var warranty_status = record_data.warranty_status;
                                var activation_date = record_data.activation_date;
                               // var warranty_unit = record_data.warranty_unit;

                                if (warranty_status == 3 || warranty_status == 4) {
                                    activation_date =  moment.tz(activation_date, constants.timeZone()).format('DD/MM/YYYY');
                                } else activation_date = '';

                                var dataDateArr = {
                                    //warranty_time:warranty_time,
                                    returnable_time:returnable_time,
                                    change_time:change_time,
                                    warranty_status:warranty_status,
                                    activation_date:activation_date,
                                    arrWarrantyStatus:null,
                                    //warranty_unit:warranty_unit
                                }
                                var arrs = constants.returnTimeCustomText(dataDateArr);
                                if (!constants.isEmpty(data.return_type)) {
                                    if (data.return_type == 1){
                                        text_data = arrs.returnable_time_text;
                                    }else if (data.return_type == 0){
                                        text_data = arrs.change_time_text;
                                    }
                                }
                                //text_data = (!constants.isEmpty(data.serial_number.product.model_code))  ? data.serial_number.product.model_code:'';
                            }
                        }
                        data.time_exchange_return_text = text_data;
                    }
                },
                reason_name_return_text: {
                    name: 'reason_name_return_text',
                    type: "String",
                    label: 'Lý do đổi - trả',
                    width: 13,
                    sortable: false,
                    computed: (data) => {
                        var text_data = "";
                        if (!constants.isEmpty(data.setting_reason_reject)){
                            if (!constants.isEmpty(data.setting_reason_reject.reason_name)) {
                                text_data = data.setting_reason_reject.reason_name;
                            }
                        }
                        data.reason_name_return_text = text_data;
                    }
                },
                reason_detail_return_text: {
                    name: 'reason_detail_return_text',
                    type: "String",
                    label: 'Lý do chi tiết',
                    width: 13,
                    sortable: false,
                    computed: (data) => {
                        var text_data = "";
                        if (!constants.isEmpty(data.reason_detail)){
                            text_data = data.reason_detail;
                        }
                        data.reason_detail_return_text = text_data;
                    }
                },
                date_cancel_request_text: {
                    name: 'date_cancel_request_text',
                    type: "Date",
                    label: 'Ngày hủy yêu cầu',
                    width: 13,
                    sortable: false,
                    computed: (data) => {
                        var date_data = null;
                        if (data.current_status == 2){
                            date_data = data.modified_date;
                        }
                        data.date_cancel_request_text = date_data;
                    }
                },
                appraisal_organization_text: {
                    name: 'appraisal_organization_text',
                    type: "String",
                    label: 'Đơn vị thẩm định',
                    width: 13,
                    sortable: false,
                    computed: (data) => {
                        var text_data = "";
                        if (!constants.isEmpty(data.appraisal_product)) {
                            if (!constants.isEmpty(data.appraisal_product.appraisal)){
                                if (!constants.isEmpty(data.appraisal_product.appraisal.appraisal_organization)){
                                    text_data = (!constants.isEmpty(data.appraisal_product.appraisal.appraisal_organization.name))  ? data.appraisal_product.appraisal.appraisal_organization.name:'';
                                }
                            }
                        }
                        data.appraisal_organization_text = text_data;
                    }
                },
                phone_appraisal_organization_text: {
                    name: 'phone_appraisal_organization_text',
                    type: "String",
                    label: 'SĐT đơn vị thẩm định',
                    width: 13,
                    sortable: false,
                    computed: (data) => {
                        var text_data = "";
                        if (!constants.isEmpty(data.appraisal_product)) {
                            if (!constants.isEmpty(data.appraisal_product.appraisal)){
                                if (!constants.isEmpty(data.appraisal_product.appraisal.appraisal_organization)){
                                    var phone_number = (!constants.isEmpty(data.appraisal_product.appraisal.appraisal_organization.phone_number))  ? data.appraisal_product.appraisal.appraisal_organization.phone_number:'';
                                    text_data = phone_number.replace('+84', '0');
                                }
                            }
                        }
                        data.phone_appraisal_organization_text = text_data;
                    }
                },
                province_appraisal_organization_text: {
                    name: 'province_appraisal_organization_text',
                    type: "String",
                    label: 'Tỉnh/TP của ĐV thẩm định',
                    width: 13,
                    sortable: false,
                    computed: (data) => {
                        var text_data = "";
                        if (!constants.isEmpty(data.appraisal_product)) {
                            if (!constants.isEmpty(data.appraisal_product.appraisal)){
                                if (!constants.isEmpty(data.appraisal_product.appraisal.appraisal_organization)){
                                if (!constants.isEmpty(data.appraisal_product.appraisal.appraisal_organization.provinces)){
                                    text_data = (!constants.isEmpty(data.appraisal_product.appraisal.appraisal_organization.provinces.name))  ? data.appraisal_product.appraisal.appraisal_organization.provinces.name:'';
                                }
                                }
                            }
                        }
                        data.province_appraisal_organization_text = text_data;
                    }
                },
                fullname_appraisal_text: {
                    name: 'fullname_appraisal_text',
                    type: "String",
                    label: 'Nhân viên thẩm định',
                    width: 13,
                    sortable: false,
                    computed: (data) => {
                        var text_data = "";
                        if (!constants.isEmpty(data.appraisal_product)) {
                            if (!constants.isEmpty(data.appraisal_product.appraisal)){
                                if (!constants.isEmpty(data.appraisal_product.appraisal.users)){
                                    text_data = (!constants.isEmpty(data.appraisal_product.appraisal.users.full_name))  ? data.appraisal_product.appraisal.users.full_name:'';
                                }
                            }
                        }
                        data.fullname_appraisal_text = text_data;
                    }
                },
                day_reception_text: {
                    name: 'day_reception_text',
                    type: "Date",
                    label: 'Ngày tiếp nhận',
                    width: 13,
                    sortable: false,
                    computed: (data) => {
                        var date_data = null;
                        if (!constants.isEmpty(data.appraisal_product)) {
                            if (!constants.isEmpty(data.appraisal_product.created_date)) {
                                date_data = data.appraisal_product.created_date;
                            }
                        }
                        data.day_reception_text = date_data;
                    }
                },
                appraisal_date_text: {
                    name: 'appraisal_date_text',
                    type: "Date",
                    label: 'Ngày thẩm định',
                    width: 13,
                    sortable: false,
                    computed: (data) => {
                        var date_data = null;
                        if (!constants.isEmpty(data.appraisal_product)) {
                            if (!constants.isEmpty(data.appraisal_product.modified_date)) {
                                date_data = data.appraisal_product.modified_date;
                            }
                        }
                        data.appraisal_date_text = date_data;
                    }
                },
                current_status_text: {
                    name: 'current_status_text',
                    type: "String",
                    label: 'Trạng thái thẩm định',
                    width: 13,
                    sortable: false,
                    computed: (data) => {
                        var text_data = "";
                        var list_status = [{ value: 6, label: 'Chờ gửi yêu cầu'},{ value: 0, label: 'Đang yêu cầu'}, { value: 1, label: 'Chờ thẩm định'}, { value: 2, label: 'Hủy yêu cầu'}, { value: 3, label: 'Tự động duyệt'}, { value: 4, label: 'Không duyệt'}, { value: 5, label: 'Đã duyệt'}];
                        if (!constants.isEmpty(data.current_status)) {
                            for (var i=0;i<list_status.length;i++){
                                if (parseFloat(list_status[i].value) == parseFloat(data.current_status)){
                                    text_data = list_status[i].label;
                                    break;
                                }
                            }
                        }
                        data.current_status_text = text_data;
                    }
                },
                note_appraisal_text: {
                    name: 'note_appraisal_text',
                    type: "String",
                    label: 'Ghi chú thẩm định',
                    width: 13,
                    sortable: false,
                    computed: (data) => {
                        var text_data = "";
                        if (!constants.isEmpty(data.appraisal_product)) {
                            if (!constants.isEmpty(data.appraisal_product.note)) {
                                text_data = data.appraisal_product.note;
                            }
                        }
                        data.note_appraisal_text = text_data;
                    }
                },
            fied_detail: {
                refs: '  id return_type reason_detail reason_id created_date modified_date current_status request_activation { id customer_profile { address province { id name } district { id name } ward { id name } full_name phone_number  user { user_type } } customer_name } user_created user_created_request { full_name phone_number organization_account { organization { phone_number provinces { name id } name } } } serial_number { production_order_code serial_number product { model_code name categories { id name } } product_serial_number_info {  activation_date warranty_status warranty_time returnable_time change_time warranty_status warranty_unit } } change_serial_number { id product { model_code name categories { id name } } serial_number product_serial_number_info { activation_date warranty_status } } setting_reason_reject { id reason_name } appraisal_product { id appraisal { appraisal_organization { id name phone_number provinces { id name } } users { full_name id } modified_date } created_date modified_date note }  ',
                display: false
            }
        },)
    }

}